import { type StoreDefinition, type Pinia, type StateTree, getActivePinia } from 'pinia'
import Vue from 'vue'

export function wrapStoreWithActivePinia<Id extends string, S extends StateTree, G, A>(
  storeDefinition: StoreDefinition<Id, S, G, A>
) {
  const wrappedStore = ((pinia?: Pinia) => {
    // As a last resort, if there's no active pinia, as for the audi app for some reason, try to get
    // the pinia instance from the Vue.prototype
    const piniaInstance = pinia || getActivePinia() || Vue.prototype.$pinia

    if (!piniaInstance) {
      throw new Error('Pinia is not initialized. Make sure to install pinia in the app before using it in a library.')
    }

    return storeDefinition(piniaInstance)
  }) as StoreDefinition<Id, S, G, A>

  return Object.assign(wrappedStore, { $id: storeDefinition.$id })
}
